<template>
  <path pid="0" d="M19.5 18.5a5.51 5.51 0 10-4.24-2h-4.52a5.5 5.5 0 10-4.24 2zm0-9A3.5 3.5 0 1116 13a3.5 3.5 0 013.5-3.5zM3 13a3.5 3.5 0 113.5 3.5A3.5 3.5 0 013 13z"/>
</template>
